import { render } from "./Channels.vue?vue&type=template&id=46c20daf&scoped=true&lang=pug"
import script from "./Channels.vue?vue&type=script&lang=js"
export * from "./Channels.vue?vue&type=script&lang=js"

import "./Channels.vue?vue&type=style&index=0&id=46c20daf&lang=scss&scoped=true"
import "./Channels.vue?vue&type=style&index=1&id=46c20daf&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46c20daf"]])

export default __exports__